import { render, staticRenderFns } from "./blocklist-corretoras.vue?vue&type=template&id=468616be"
import script from "./blocklist-corretoras.vue?vue&type=script&lang=js"
export * from "./blocklist-corretoras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports